/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOAuthConfigRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {GetOAuthConfigResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const getOauthConfig = (request: GetOAuthConfigRequest, options?: CashRequestOptions) => post<GetOAuthConfigRequest, GetOAuthConfigResponse>("/2.0/cash/get-oauth-config", request, {...options, rejectOnError: true })